import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { ButtonModule, IconsModule, ModalModule, NotificationsModule, UiComponentsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, FinFormsModule, MediaQueryService, PipesModule } from '@fcom/common';
import { GtmModule } from '@fcom/common/gtm';
import { BoundContainerComponent, CommonBookingComponentsModule } from '@fcom/common-booking/components';
import { UpgradeAvailabilityService } from '@fcom/loyalty-plus/services/upgrade-availability.service';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';
import { LoginModule } from '@fcom/common/login';
import { DataCloudModule } from '@fcom/common/datacloud';
import { QualtricsModule } from '@fcom/common/qualtrics/qualtrics.module';

import { DimensionsAndDetailsModalService } from './services/dimensions-and-details-modal.service';
import { BookingNotificationModule } from '../../components/booking-notification/booking-notification.module';
import { BookingCommonModule } from '../common/booking-common.module';
import { BookingTicketSelectionViewComponent } from './components/booking-ticket-selection-view.component';
import { BoundSelectionListComponent } from './components/offers/bound-selection-list.component';
import { TicketSelectionHeaderComponent } from './components/offers/ticket-selection-header.component';
import { AirBoundsBookingTicketSelectionViewComponent } from './components/air-bounds-booking-ticket-selection-view.component';
import { OptimizedAirBoundsBoundSelectionListComponent } from './components/air-bounds/optimize-bound-selection-list.component';
import { AirBoundsBoundSelectionComponent } from './components/air-bounds/bound-selection.component';
import { BookingTicketSelectionRouteComponent } from './routes/booking-ticket-selection-route.component';
import { TicketSelectionGuard } from './services/ticket-selection.guard';
import { BookingAirBoundsService, BookingOfferListService, BookingMultiCityService } from './services';
import { ItineraryUpgradeAvailabilityComponent } from './components/itinerary-upgrade-availability/itinerary-upgrade-availability.component';
import { SuperLightWarningModalComponent } from './components/air-bounds/super-light-warning-modal/super-light-warning-modal.component';
import { MultiCityViewComponent } from './components/multi-city-view/multi-city-view.component';
import { MultiCityFareFamilyComponent } from './components/multi-city-fare-family/multi-city-fare-family.component';
import { MultiCityFareFamilySelectorComponent } from './components/multi-city-fare-family-selector/multi-city-fare-family-selector.component';
import { MultiCityBoundsComponent } from './components/multi-city-bounds/multi-city-bounds.component';
import { MultiCityJourneyPriceComponent } from './components/multi-city-journey-price/multi-city-journey-price.component';

@NgModule({
  imports: [
    BookingCommonModule,
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    CmsModule,
    DirectiveModule,
    FinFormsModule,
    CommonServiceFormsModule,
    GtmModule,
    DataCloudModule,
    PipesModule,
    UiTranslateModule,
    ButtonModule,
    IconsModule,
    ModalModule,
    NotificationsModule,
    UiComponentsModule,
    NotificationsModule,
    BookingNotificationModule,
    LoginModule,
    QualtricsModule,
  ],
  declarations: [
    BookingTicketSelectionRouteComponent,
    BookingTicketSelectionViewComponent,
    BoundSelectionListComponent,
    TicketSelectionHeaderComponent,
    AirBoundsBookingTicketSelectionViewComponent,
    AirBoundsBoundSelectionComponent,
    ItineraryUpgradeAvailabilityComponent,
    OptimizedAirBoundsBoundSelectionListComponent,
    SuperLightWarningModalComponent,
    MultiCityFareFamilyComponent,
    MultiCityViewComponent,
    MultiCityFareFamilySelectorComponent,
    MultiCityBoundsComponent,
    MultiCityJourneyPriceComponent,
  ],
  exports: [BookingTicketSelectionRouteComponent, TicketSelectionHeaderComponent, BoundContainerComponent],
  providers: [
    BookingOfferListService,
    BookingMultiCityService,
    BookingAirBoundsService,
    TicketSelectionGuard,
    MediaQueryService,
    UpgradeAvailabilityService,
    DimensionsAndDetailsModalService,
  ],
})
export class TicketSelectionModule {}
